import React, { useState, useEffect } from 'react';
import { FaImages, FaArrowLeft, FaArrowRight, FaTimes } from 'react-icons/fa';
import Preloader from '../components/Preloader';
import '../styles/Infrastructure.css';
import image1 from '../assets/images/infrastructure/1.jpg';
import image2 from '../assets/images/infrastructure/2.jpg';
import image3 from '../assets/images/infrastructure/3.jpg';
import image4 from '../assets/images/infrastructure/4.jpeg';
import image5 from '../assets/images/infrastructure/5.jpg';
import image6 from '../assets/images/infrastructure/6.jpg';
import image13 from '../assets/images/infrastructure/13.jpeg';
import image7 from '../assets/images/infrastructure/7.jpeg';
import image8 from '../assets/images/infrastructure/8.jpeg';
import image9 from '../assets/images/infrastructure/9.jpeg';
import image10 from '../assets/images/infrastructure/10.jpeg';
import image11 from '../assets/images/infrastructure/11.jpeg';
import image12 from '../assets/images/infrastructure/12.jpeg';
import image14 from '../assets/images/infrastructure/14.jpg';


/* ================= IMAGE DATA ================= */
const infrastructureImages = [
  { id: 1, image: image1},   //1
  { id: 2, image: image2},  //2
  { id: 3, image: image3},  //3
  { id: 6, image: image5},  //4
  { id: 7, image: image6},  //5
  { id: 8, image: image14}, //6
  { id: 13, image: image13},  //8
  { id: 5, image: image4},  
  { id: 14, image: image11}, //13
  { id: 15, image: image12}, //14
  { id: 12, image: image10}, //12
  { id: 10, image: image8}, //10
  { id: 9, image: image7},  //9
  { id: 11, image: image9},  //11
];

const Infrastructure = () => {
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [direction, setDirection] = useState('');

  /* ================= PRELOADER ================= */
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  /* ================= BODY SCROLL LOCK ================= */
  useEffect(() => {
    document.body.style.overflow = currentIndex !== null ? 'hidden' : 'auto';
  }, [currentIndex]);

  /* ================= KEYBOARD CONTROLS ================= */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentIndex === null) return;

      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);

  if (loading) return <Preloader />;

  /* ================= HANDLERS ================= */
  const openModal = (index) => {
    setDirection('');
    setCurrentIndex(index);
  };

  const closeModal = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setDirection('slide-left');
    setCurrentIndex((prev) =>
      prev === infrastructureImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setDirection('slide-right');
    setCurrentIndex((prev) =>
      prev === 0 ? infrastructureImages.length - 1 : prev - 1
    );
  };

  return (
    <div className="infrastructure-page-wrapper">

      {/* ================= HEADER ================= */}
      <section className="infrastructure-header text-center py-5 bg-navy text-white">
        <div className="container " style={{marginTop:"60px"}}>
          <div className="d-inline-flex align-items-center gap-3 mb-3">
           
            <div>
              <h1 className="h2 fw-bold">
                 <span className="p-3 rounded-lg infra-icon-box">
              <FaImages />
            </span>
                Infrastructure <span className="highlight">Gallery</span>
              </h1>
              <p className="text-light sub-tittle mb-0">
                Visual journey through our manufacturing facilities
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= GALLERY GRID ================= */}
      <div className="container py-5">
        <div className="row g-3">
          {infrastructureImages.map((item, index) => (
            <div 
              className="col-lg-2 col-md-3 col-sm-4 col-6"
              key={item.id}
            >
              <div 
                className="gallery-image-wrapper"
                onClick={() => openModal(index)}
              >
                <div className="image-container-square">
                  <img
                    src={item.image}
                    alt="Sri Krishna Paper Board"
                    className="gallery-image-square"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ================= MODAL ================= */}
      {currentIndex !== null && (
        <div className="image-modal-backdrop" onClick={closeModal}>
          <div className="image-modal-container" onClick={(e) => e.stopPropagation()}>

            <button className="image-modal-close" onClick={closeModal}>
              <FaTimes />
            </button>

            <button className="modal-nav-btn prev" onClick={prevImage}>
              <FaArrowLeft />
            </button>

            <button className="modal-nav-btn next" onClick={nextImage}>
              <FaArrowRight />
            </button>

            <div className="image-modal-content">
              <div className={`modal-image-wrapper ${direction}`}>
                <img
                  src={infrastructureImages[currentIndex].image}
                  alt="Sri Krishna Paper Board"
                  className="modal-image"
                />
              </div>

              <div className="modal-caption">
                {/* <h4>{infrastructureImages[currentIndex].title}</h4> */}
                <p className="mb-0">
                  {currentIndex + 1} / {infrastructureImages.length}
                </p>
              </div>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default Infrastructure;